import { Cookie } from '@libs/common-next';
import { create } from 'zustand';

interface OverrideStore {
    overrides: Record<string, string | boolean>;
    setOverride: (override: Record<string, string | boolean>) => void;
}
export const useOverrides = create<OverrideStore>(set => ({
    overrides: JSON.parse(Cookie.get('x-petm-override') ?? '{}'),
    setOverride: overrides => set({ overrides }),
}));
